import { CommentsList } from './comments-list'

export { CommentsList }
